import { Component } from '@angular/core';
import { PlatformsService } from '../../../../core/services/platforms.service';
import { fuseAnimations } from '../../../../core/animations';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'share-links',
    templateUrl: './shareLinks.component.html',
    styleUrls: ['./shareLinks.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class ShareLinksComponent {
  platforms = [];
  displayedColumns = [ 'name', 'link' ];
  embedUrl = 'https://elearning.pfefferstern.ch/elearning?color=&data=';

  constructor(private platformsService: PlatformsService,
              public snackBar: MatSnackBar ) {
    this.getPlatforms();
  }

  getPlatforms() {
    this.platformsService.getPlatforms().subscribe((res: any) => {
      if (res && res.length) {
        let result = [];
        for (let i = 0; i < res.length; i++) {
          if (res[i]) {
            let id = btoa(res[i].id);
            res[i].embedUrl = this.embedUrl + id;
            result.push(res[i]);
            if (res[i].space && res[i].space.length) {
              for (let s = 0; s < res[i].space.length; s++) {
                const spaceId = btoa(res[i].id + '#' + res[i].space[s].id);
                let data = {
                  title: res[i].title + '(' + res[i].space[s].name + ')',
                  type: 'space',
                  embedUrl: this.embedUrl + spaceId,
                  id: res[i].id + '#' + res[i].space[s].id
                };
                result.push(data);
              }
            }
          }
        }
        this.platforms = result;
      }
    });
  }

  copyCodeFunc(id) {
    let copyText: any = document.getElementById('copyEmbedUrl_' + id);
    copyText.select();
    document.execCommand('copy');
    this.snackBar.open('Copied' , '' , {duration: 2500});
  }

}
